export default Object.freeze([
    'page_Page',
    'page_NavigationLink',
    'page_NavigationSelectedContextPage',
    'navHeading_NavHeading',
    'navHeading_TabNavHeading'
]);
